import Vue from "vue";
import router from '../../router';
import VueSweetalert2 from 'vue-sweetalert2';

// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);
export default Vue.extend({
    data: () => ({
        company_name : '',
        adminName : '',
        email:'',
        password : '',
        show2: false,
        Data: true,
        otp : '',
        registerLoading : false,
        companyNameRequired : [
            (v: boolean) => !!v || "Company name is required",
            //@ts-ignore
            (v: boolean) =>/^.{2,}$/.test(v) || 'Company name must have at least 2 character'
        ],
        nameRequired : [
            (v: boolean) => !!v || "Name is required",
            //@ts-ignore
            (v: boolean) =>/^.{4,}$/.test(v) || 'Name must have at least 4 character'
        ],
        emailRequired: [
            (v: boolean) => !!v || "Email is required",
            //@ts-ignore
            (v: boolean) =>/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/.test(v) || 'Please choose a valid email address'
        ],
        passwordRequired: [
            (v: boolean) => !!v || "Password is required",
            //@ts-ignore
            (v: boolean) => /^.{8,}$/.test(v) ||  "Password must have at least 8 charecter"
        ],
        otpRequired :[
            v => ( v && v > 0 ) || "Please fill the field.",
            //@ts-ignore
            (v: boolean) => /^[0-9]{6}$/.test(v) 
        ]
    }),
    created() {
        
    },
    methods: {
        toggleData(){
           this.Data = !this.Data;
        },
        async register(){
            try{
                if (this.$refs.registerForm.validate()) {
                    this.registerLoading = true;
                                    
                    let resp = await this.$http.post('/auth/createAccountByEmail', {
                        company_name: this.company_name ,
                        name: this.adminName,
                        username: this.email,
                        password: this.password,
                        role_id: 3,
                    })
                    console.log("resp",resp); 
                    console.log("data",resp.data); 
                    if (resp.status===200) {
                        console.log("this.email",this.email); 
                        this.registerLoading = false;
                        this.alertMsg('One time password sent to your email, verify to continue.', 'success', 'Confirm');
                        localStorage.setItem('adminemail',this.email);
                        this.Data = false;
                    }
                }
            }catch (err) {
                console.log('error',err);
                console.log('error',err.response);
                console.log('status',err.response.status);
                console.log('.data.role_id',err.response.data.role_id);
                this.registerLoading = false;
                if (err.response.status==409 && err.response.data.role_id==3){
                    this.alertMsg('You have already registered using same mail id, login to continue.', 'error','Oops!!')
                }
                else if (err.response.status==409 && err.response.data.role_id==1) {
                    this.alertMsg('Your email id dose not have permission to register as you have already registered as super-admin.', 'error', 'Oops!!')
                }
                else if (err.response.status==409 && err.response.data.role_id==4) {
                    this.alertMsg('Your email id dose not have permission to register as you have already registered as admin.', 'error', 'Oops!!')
                }
                else if (err.response.status==409 && err.response.data.role_id==2) {
                    this.alertMsg('Your email id dose not have permission to register as you have already registered as student.', 'error', 'Oops!!')
                }
                else if (err.response.status==408) {
                    this.alertMsg('This email-id is being used on our student portal.', 'error', 'Oops!!')
                }
                else{
                    this.alertMsg('Something went wrong. Please try again later.', 'error', 'Oops!!')
                }
            }
        },
        
        async otpCall(){
            try {
                console.log(" OTP recieved ", this.otp);
                console.log("email ",localStorage.getItem('adminemail'));
                let email = localStorage.getItem('adminemail');
                let response = await this.$http.post('/auth/verifyEmailWithOTP',{
                    username: email,
                    otp: this.otp,
                });
      
                response = response.data;
                console.log("**Response after otp verification**", response);
                this.alertMsg('Otp verified and registration complete.', 'Sucess', 'Confirm');
                localStorage.removeItem('adminemail');
                this.$router.replace({ name: 'login' })
            } catch (err) {
                // error handling
                console.log("**Error in OTP**", err.response);
                if (err.response.status=='410') {
                    this.alertMsg('OTP expired, try again.','error', 'Oops!!')
                }
            }
        },

        alertMsg(message,type,title) {
            this.$swal({
                title: title,
                text: message,
                icon: type,
                confirmButtonText: 'OK',
                customClass: 'swal-title'
            })
        }
    }
});
